import React from 'react';

export const LogoMark = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="flask-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1A3A64"/>
        <stop offset="40%" stopColor="#00AEEF"/>
        <stop offset="70%" stopColor="#00C4AD"/>
        <stop offset="100%" stopColor="#83CF44"/>
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="14" fill="#1A3A64"/>
    <path d="M27 12 H37 V16 L42 28 L32 54 L22 28 L27 16 Z" fill="url(#flask-gradient)" opacity="0.9"/>
    <rect x="26" y="10" width="12" height="4" rx="1" fill="white" opacity="0.9"/>
    <path d="M30 18 L32 48 L34 18 Z" fill="white" opacity="0.25"/>
  </svg>
);

export const LogoFull = ({ size = 'default', variant = 'light', className = '' }) => {
  const h = size === 'small' ? 28 : size === 'large' ? 40 : 32;
  const dark = variant === 'dark';
  
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={h} />
      <span className="font-semibold tracking-tight" style={{ 
        fontFamily: 'Outfit, sans-serif',
        fontSize: h * 0.6
      }}>
        <span style={{ color: dark ? '#FFFFFF' : '#1A3A64' }}>Insure</span>
        <span className="text-gradient">Lab</span>
      </span>
    </div>
  );
};

export const LogoImage = ({ variant = 'light', height = 36, className = '' }) => {
  const src = variant === 'dark' ? '/logo-dark.jpeg' : '/logo-light.jpeg';
  return <img src={src} alt="InsureLab" style={{ height }} className={`object-contain ${className}`} />;
};
